import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { UpgradeModule } from '@angular/upgrade/static';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NgrxFormsModule } from 'ngrx-forms';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { AuthenticationSelectors } from '../auth/state/authentication.selectors';
import { LocationsService } from '../locations/state/locations.service';
import { ReasonsSettingsActions } from '../reasons/state/reasons-settings.actions';
import { ReasonsSettingsEffects } from '../reasons/state/reasons-settings.effects';
import { ReasonsSettingsReducer, STORE_FEATURE_KEY_REASONS } from '../reasons/state/reasons-settings.reducer';
import { ReasonsSettingsSelectors } from '../reasons/state/reasons-settings.selectors';
import { AppointmentResourceSettingsActions } from '../resources/state/appointment-resource-settings.actions';
import { AppointmentResourceSettingsEffects } from '../resources/state/appointment-resource-settings.effects';
import {
    AppointmentResourceSettingsReducer,
    STORE_FEATURE_KEY_RESOURCES
} from '../resources/state/appointment-resource-settings.reducer';
import { AppointmentResourceSettingsSelectors } from '../resources/state/appointment-resource-settings.selectors';
import { UserModule } from '../user/user.module';
import { AdaptiveRulesAdminComponent } from './adaptive-rules-admin.component';
import { AdaptiveRulesComponent } from './adaptive-rules.component';
import { CurrentRuleComponent } from './current-rule.component';
import { RuleControlsComponent } from './rule-controls.component';
import { RuleEntryTableComponent } from './rule-entry-table.component';
import { AdaptiveRulesService } from './state/adaptive-rules.service';
import { FeatureFlagsModule } from '../feature-flag/feature-flag.module';

@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        UpgradeModule,
        FormsModule,
        NgrxFormsModule,
        ReactiveFormsModule,
        DropdownModule,
        StoreModule.forFeature(STORE_FEATURE_KEY_REASONS, ReasonsSettingsReducer),
        StoreModule.forFeature(STORE_FEATURE_KEY_RESOURCES, AppointmentResourceSettingsReducer),
        EffectsModule.forFeature([ReasonsSettingsEffects]),
        EffectsModule.forFeature([AppointmentResourceSettingsEffects]),
        TableModule,
        CheckboxModule,
        TooltipModule,
        UserModule,
        FeatureFlagsModule
    ],
    declarations: [
        AdaptiveRulesComponent,
        RuleEntryTableComponent,
        CurrentRuleComponent,
        RuleControlsComponent,
        AdaptiveRulesAdminComponent
    ],
    providers: [
        AdaptiveRulesService,
        AuthenticationSelectors,
        ReasonsSettingsSelectors,
        AppointmentResourceSettingsSelectors,
        LocationsService
    ],
    entryComponents: [
        AdaptiveRulesComponent
    ],
    exports: [
        // AdaptiveRulesComponent
    ]
})
export class AdaptiveRulesModule {
}
